import React from "react"
import {TableRowItem} from "./Table"
import styles from "./OnDemandTable.module.css"
import {tableData} from "./rawData"

export default function OnDemandTable(props) {
    const {onClickShowDetail, model} = props

    const onClickRowItem = () => {}

    return (
        <div className={styles.wrapper}>
            <table className={styles.table}>
                <thead className={styles.tableHead}>
                    <tr className={styles.tableRowHeader}>
                        <th className={`${styles.tableCell} ${styles.tableCellHeader}`}>Task name</th>
                        <th className={`${styles.tableCell} ${styles.tableCellHeader}`}>Role availability</th>
                        <th className={`${styles.tableCell} ${styles.tableCellHeader}`}>Department</th>
                        <th className={`${styles.tableCell} ${styles.tableCellHeader}`}>Tasks Assigned</th>
                        <th className={`${styles.tableCell} ${styles.tableCellHeader}`}>Added</th>
                        <th className={`${styles.tableCell} ${styles.tableCellHeader}`}></th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((item) => (
                        <TableRowItem
                            key={item.id}
                            data={item}
                            onClickShowDetail={onClickShowDetail}
                            onClickRowItem={onClickRowItem}
                            model={model}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    )
}
